import React, { useState } from "react";
import './LoginForm.css';
import RecuperarSenhaForm from '../RecuperarLoginForm/RecuperarSenhaForm';
import { FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function setCookie(nome, valor, dias) {
    var expires = "";
    if (dias) {
        var data = new Date();
        data.setTime(data.getTime() + (24*60*60*1000 * dias));
        expires = "; expires=" + data.toGMTString();
    }
    document.cookie = nome + "=" + (valor || "") + expires + "; path=/";
}

function LoginForm () {
    const [form, setForm] = useState({
        email: "",
        senha: ""
    });

    const [div_esqueceu_senha, set_div_esqueceu_senha] = useState(false);
    const [showChave, setShowChave] = useState(false);
    const navigate = useNavigate();

    const btn_visibilidade_chave = () => {
        setShowChave((prev) => !prev);
        var x = document.getElementById("iptSenha");
        if (x.type === "password") {
          x.type = "text";
        } else {
          x.type = "password";
        }
    };

    const logar = (evento) => {
        evento.preventDefault(); 

        Swal.fire({
            html: 'Verificando o seu login...',
            imageUrl: 'ufo.gif',
            imageWidth: 100,
            imageHeight: 100,
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/login`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: form.email,
                senha: form.senha
            })
        })
        .then((response) => response.json())
        .then((result) => {
            if (result.status === "erro") {
                Swal.fire({
                    text: result.mensagem,
                    icon: "error"
                });
            } else {
                if (result.status === "senha_insegura") {
                    Swal.fire({
                        title: "Atualização de senha necessária!",
                        text: result.mensagem,
                        icon: "warning",
                    }).then(() => {
                        setCookie("info", result.token, 1);
                        navigate("/alterar_senha_obrigatoria?obrigatorio=true&token=" + result.token); 
                    });

            }else if (result.status != "ok") {
                    Swal.fire({
                        title: "Primeiro contato detectado!",
                        text: "Continue para desbloquear seu acesso. 🛸",
                        icon: "info",
                    }).then(() => {
                        setCookie("info", result.token, 1); // Salva o token em cookies       
                        navigate("/cadastrar_token"); // Redireciona para a página de validação
                    });
                } else {
                    Swal.fire({
                        title: "Login bem-sucedido!",
                        text: "Prepare-se para validar seu acesso. 🚀🌠",
                        icon: "success",
                    }).then(() => {
                        setCookie("info", result.token, 1); // Salva o token em cookies       
                        navigate("/validar"); // Redireciona para a página de validação
                    });
                    
                }
            }
        })
        .catch((error) => {
            console.log(error);
            Swal.fire({
                title: "Ops!",
                text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                icon: "warning"
            });
        });
    };

    const detectar_tecla_enter = (evento) => {
        if (evento.key === 'Enter') {
            logar(evento); // Chama a função ao pressionar Enter
        }
    };

    return div_esqueceu_senha ? (
        <RecuperarSenhaForm onCancel={() => set_div_esqueceu_senha(false)} />
    ) : (
        <div className='login-box'>
            <img src="telescope.png" className="logo" alt="Logo"/>
            <h1>Hubble</h1>
            <div className="input-box">
                <input
                    id="iptEmail"
                    value={form.email}
                        onChange={(e) => {
                            if (e.target.value.length <= 40) {
                                setForm({ ...form, email: e.target.value });
                            } else {
                                Swal.fire({
                                    title: "Limite excedido!",
                                    text: "Máximo de 40 caracteres permitidos para o email.",
                                    icon: "warning",
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            }
                        }}
                    onKeyDown={detectar_tecla_enter}
                    type="text"
                    placeholder='Email'
                    required
                    maxLength={50}
                />
                <FaUser className="icon" />
            </div>
            <div className="input-box">
                <input
                    id="iptSenha"
                    value={form.senha}
                    onChange={(e) => {
                        if (e.target.value.length <= 50) {
                            setForm({ ...form, senha: e.target.value });
                        } else {
                            Swal.fire({
                                title: "Limite excedido!",
                                text: "Máximo de 50 caracteres permitidos para a senha.",
                                icon: "warning",
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    }}
                    onKeyDown={detectar_tecla_enter}
                    type="password"
                    placeholder='Senha'
                    required
                />
                <button type="button" className="eye-icon" onClick={btn_visibilidade_chave}>
                    {showChave ? <FaEye  /> : <FaEyeSlash />}
                </button>
            </div>
            <div className="remember-forgot">
                <a onClick={() => set_div_esqueceu_senha(true)}>Esqueceu sua senha?</a>
            </div>
            <button type="submit" onClick={logar}>Entrar</button>
        </div>
    );
}

export default LoginForm;
